/**
 * Custom JavaScript for A*Vault Shopify Theme
 * Place this file in: assets/custom-scripts.js
 */

// Smooth scrolling function
function scrollToSection(targetId) {
  const element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Particle animation enhancement
document.addEventListener('DOMContentLoaded', function() {
  // Add intersection observer for animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  // Observe all feature cards
  document.querySelectorAll('.feature-card, .testimonial-card, .premium-product-card').forEach(card => {
    observer.observe(card);
  });

  // Enhanced button interactions
  document.querySelectorAll('.btn').forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px) scale(1.02)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0) scale(1)';
    });
  });

  // Form enhancements
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    const input = newsletterForm.querySelector('input[type="email"]');
    const button = newsletterForm.querySelector('button[type="submit"]');
    
    if (input && button) {
      input.addEventListener('focus', function() {
        this.parentElement.style.transform = 'scale(1.02)';
      });
      
      input.addEventListener('blur', function() {
        this.parentElement.style.transform = 'scale(1)';
      });
    }
  }

  // Product card hover effects
  document.querySelectorAll('.premium-product-card').forEach(card => {
    const details = card.querySelector('.premium-product-details');
    
    card.addEventListener('mouseenter', function() {
      if (details) {
        details.style.opacity = '1';
      }
    });
    
    card.addEventListener('mouseleave', function() {
      if (details) {
        details.style.opacity = '0';
      }
    });
  });

  // Stats counter animation
  function animateCounters() {
    const counters = document.querySelectorAll('.hero-stat-number');
    
    counters.forEach(counter => {
      const target = counter.textContent;
      const numericValue = parseFloat(target.replace(/[^\d.]/g, ''));
      
      if (!isNaN(numericValue)) {
        let current = 0;
        const increment = numericValue / 50;
        const suffix = target.replace(/[\d.]/g, '');
        
        const timer = setInterval(() => {
          current += increment;
          if (current >= numericValue) {
            counter.textContent = target;
            clearInterval(timer);
          } else {
            counter.textContent = Math.floor(current) + suffix;
          }
        }, 50);
      }
    });
  }

  // Trigger counter animation when hero is visible
  const heroSection = document.querySelector('.hero-matrix-section');
  if (heroSection) {
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(animateCounters, 1000);
          heroObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    heroObserver.observe(heroSection);
  }
});

// Shopping cart functionality enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Add to cart button enhancements
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const button = this.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      button.textContent = 'Adding...';
      button.disabled = true;
      
      // Re-enable button after 2 seconds (adjust based on your cart logic)
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
  });
});

// Mobile menu enhancements (if using custom header)
function toggleMobileMenu() {
  const menu = document.querySelector('.mobile-menu');
  if (menu) {
    menu.classList.toggle('active');
  }
}



// Newsletter form success handling
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      const email = this.querySelector('input[type="email"]').value;
      
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        e.preventDefault();
        alert('Please enter a valid email address.');
        return;
      }
      
      // Show loading state
      const button = this.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      button.textContent = 'Joining...';
      button.disabled = true;
      
      // Note: Form will submit normally, this is just for UX
    });
  }
});
/**
 * Custom JavaScript for A*Vault Shopify Theme
 * Place this file in: assets/custom-scripts.js
 */

// Smooth scrolling function
function scrollToSection(targetId) {
  const element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Particle animation enhancement
document.addEventListener('DOMContentLoaded', function() {
  // Add intersection observer for animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  // Observe all cards
  document.querySelectorAll('.stat-card, .timeline-item, .mindset-point').forEach(card => {
    observer.observe(card);
  });

  // Enhanced button interactions
  document.querySelectorAll('.btn-hero, .btn-primary, .btn-secondary, .mission-button').forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px) scale(1.02)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0) scale(1)';
    });
  });

  // Stats counter animation
  function animateCounters() {
    const counters = document.querySelectorAll('.stat-number');
    
    counters.forEach(counter => {
      const target = counter.textContent;
      const numericValue = parseFloat(target.replace(/[^\d.]/g, ''));
      
      if (!isNaN(numericValue)) {
        let current = 0;
        const increment = numericValue / 50;
        const suffix = target.replace(/[\d.]/g, '');
        
        const timer = setInterval(() => {
          current += increment;
          if (current >= numericValue) {
            counter.textContent = target;
            clearInterval(timer);
          } else {
            counter.textContent = Math.floor(current) + suffix;
          }
        }, 50);
      }
    });
  }

  // Trigger counter animation when stats section is visible
  const statsSection = document.querySelector('.stats-section');
  if (statsSection) {
    const statsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(animateCounters, 500);
          statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    statsObserver.observe(statsSection);
  }

  // Timeline animations
  const timelineItems = document.querySelectorAll('.timeline-item');
  const timelineObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.3 });

  timelineItems.forEach((item, index) => {
    item.style.opacity = '0';
    item.style.transform = 'translateY(30px)';
    item.style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`;
    timelineObserver.observe(item);
  });

  // Mindset section animations
  const mindsetPoints = document.querySelectorAll('.mindset-point');
  const mindsetObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.3 });

  mindsetPoints.forEach((point, index) => {
    point.style.opacity = '0';
    point.style.transform = 'translateY(30px)';
    point.style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`;
    mindsetObserver.observe(point);
  });

  // Quote animation
  const mindsetQuote = document.querySelector('.mindset-quote');
  if (mindsetQuote) {
    const quoteObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.3 });

    mindsetQuote.style.opacity = '0';
    mindsetQuote.style.transform = 'translateY(30px)';
    mindsetQuote.style.transition = 'opacity 0.6s ease 0.4s, transform 0.6s ease 0.4s';
    quoteObserver.observe(mindsetQuote);
  }
});



// Shopping cart functionality enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Add to cart button enhancements
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const button = this.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      button.textContent = 'Adding...';
      button.disabled = true;
      
      // Re-enable button after 2 seconds (adjust based on your cart logic)
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
  });
});

// Mobile menu enhancements (if using custom header)
function toggleMobileMenu() {
  const menu = document.querySelector('.mobile-menu');
  if (menu) {
    menu.classList.toggle('active');
  }
}
/**
 * Mobile Responsive JavaScript Functions
 * Add this to your existing custom-scripts.js file
 */

// Show More functionality for mobile
function toggleShowMore(button) {
  const section = button.closest('section');
  const isActive = section.classList.contains('show-more-active');
  
  if (isActive) {
    section.classList.remove('show-more-active');
    button.textContent = button.getAttribute('data-show-text') || 'Show More';
  } else {
    section.classList.add('show-more-active');
    button.textContent = button.getAttribute('data-hide-text') || 'Show Less';
  }
}

// Initialize show more buttons
document.addEventListener('DOMContentLoaded', function() {
  const showMoreButtons = document.querySelectorAll('.show-more-btn');
  
  showMoreButtons.forEach(button => {
    // Store original text
    button.setAttribute('data-show-text', button.textContent);
    button.setAttribute('data-hide-text', 'Show Less');
  });
});

// Alternative: Dynamic element hiding based on screen size
function handleResponsiveElements() {
  const isMobile = window.innerWidth < 768;
  
  // Features Grid
  const featureCards = document.querySelectorAll('.features-grid .feature-card');
  featureCards.forEach((card, index) => {
    if (isMobile && index >= 3) {
      card.style.display = 'none';
    } else if (!isMobile) {
      card.style.display = 'block';
    }
  });
  
  // Premium Products
  const productCards = document.querySelectorAll('.premium-products-grid .premium-product-card');
  productCards.forEach((card, index) => {
    if (isMobile && index >= 2) {
      card.style.display = 'none';
    } else if (!isMobile) {
      card.style.display = 'block';
    }
  });
  
  // Testimonials
  const testimonialCards = document.querySelectorAll('.testimonials-grid .testimonial-card');
  testimonialCards.forEach((card, index) => {
    if (isMobile && index >= 2) {
      card.style.display = 'none';
    } else if (!isMobile) {
      card.style.display = 'block';
    }
  });
}

// Run on load and resize
window.addEventListener('load', handleResponsiveElements);
window.addEventListener('resize', handleResponsiveElements);

/* ===============================================
   Custom JavaScript for Enhanced Product Preview
   =============================================== */

// Initialize all product page functionality
function initializeProductMedia() {
  const mainImage = document.getElementById('main-product-image');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const zoomBtn = document.getElementById('zoom-btn');
  const zoomOverlay = document.getElementById('zoom-overlay');
  const zoomImage = document.getElementById('zoom-image');
  const zoomClose = document.getElementById('zoom-close');
  
  // Thumbnail click handlers
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const newImage = this.dataset.image;
      const newZoom = this.dataset.zoom;
      const newAlt = this.dataset.alt;
      
      // Update main image
      if (mainImage) {
        mainImage.src = newImage;
        mainImage.alt = newAlt;
        mainImage.dataset.zoom = newZoom;
      }
      
      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
  
  // Zoom functionality
  if (zoomBtn && zoomOverlay && zoomImage && zoomClose) {
    zoomBtn.addEventListener('click', function() {
      const zoomSrc = mainImage.dataset.zoom;
      zoomImage.src = zoomSrc;
      zoomOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
    
    zoomClose.addEventListener('click', function() {
      zoomOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
    
    zoomOverlay.addEventListener('click', function(e) {
      if (e.target === zoomOverlay) {
        zoomOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
}

function initializeProductTabs() {
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');
  
  tabBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetTab = this.dataset.tab;
      
      // Remove active class from all tabs and contents
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      
      // Add active class to clicked tab and corresponding content
      this.classList.add('active');
      const targetContent = document.getElementById(targetTab + '-tab');
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}

function initializeProductForm() {
  const form = document.getElementById('product-form');
  const variantSelect = document.getElementById('product-variants');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const buyNowBtn = document.getElementById('buy-now-btn');
  const quantityInput = document.getElementById('quantity');
  const quantityBtns = document.querySelectorAll('.quantity-btn');
  const successMessage = document.getElementById('add-to-cart-success');
  
  // Quantity controls
  quantityBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const action = this.dataset.action;
      const currentValue = parseInt(quantityInput.value);
      
      if (action === 'increase') {
        quantityInput.value = currentValue + 1;
      } else if (action === 'decrease' && currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  });
  
  // Variant selection
  const variantInputs = document.querySelectorAll('.variant-input');
  variantInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });
  
  function updateVariant() {
    const selectedOptions = [];
    variantInputs.forEach(input => {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    });
    
    // Find matching variant
    if (variantSelect) {
      const variants = [...variantSelect.options];
      const matchingVariant = variants.find(variant => {
        const variantTitle = variant.text.split(' - ')[0];
        return selectedOptions.every(option => variantTitle.includes(option));
      });
      
      if (matchingVariant) {
        variantSelect.value = matchingVariant.value;
        updatePrice(matchingVariant);
        updateAvailability(matchingVariant);
      }
    }
  }
  
  function updatePrice(variant) {
    const currentPrice = document.querySelector('.current-price');
    const originalPrice = document.querySelector('.original-price');
    const savingsAmount = document.querySelector('.savings-amount');
    
    if (currentPrice && variant.dataset.price) {
      currentPrice.textContent = variant.dataset.price;
    }
    
    if (originalPrice && variant.dataset.comparePrice) {
      originalPrice.textContent = variant.dataset.comparePrice;
      originalPrice.style.display = 'inline';
      if (savingsAmount) {
        const savings = parseFloat(variant.dataset.comparePrice.replace(/[^0-9.]/g, '')) - 
                       parseFloat(variant.dataset.price.replace(/[^0-9.]/g, ''));
        savingsAmount.textContent = `Save $${savings.toFixed(2)}`;
        savingsAmount.style.display = 'inline';
      }
    } else {
      if (originalPrice) originalPrice.style.display = 'none';
      if (savingsAmount) savingsAmount.style.display = 'none';
    }
  }
  
  function updateAvailability(variant) {
    const isAvailable = !variant.disabled;
    const btnText = addToCartBtn.querySelector('.btn-text');
    
    if (addToCartBtn) {
      if (isAvailable) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
        if (btnText) btnText.textContent = 'Add to Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled');
        if (btnText) btnText.textContent = 'Sold Out';
      }
    }
  }
  
  // Form submission
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success message
        if (successMessage) {
          successMessage.style.display = 'flex';
          setTimeout(() => {
            successMessage.style.display = 'none';
          }, 3000);
        }
        
        // Update cart count if cart drawer exists
        if (window.updateCartCount) {
          window.updateCartCount();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding the item to your cart. Please try again.');
      });
    });
  }
  
  // Buy Now functionality
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error with buy now:', error);
        alert('There was an error. Please try again.');
      });
    });
  }
}

// Handle related product form submissions
document.addEventListener('DOMContentLoaded', function() {
  const relatedForms = document.querySelectorAll('.related-product-form');
  
  relatedForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const button = this.querySelector('.btn-add-related');
      const originalContent = button.innerHTML;
      
      // Show loading state
      button.innerHTML = `
        <svg class="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12a9 9 0 11-6.219-8.56"/>
        </svg>
      `;
      button.disabled = true;
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success state
        button.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        `;
        
        // Reset after 2 seconds
        setTimeout(() => {
          button.innerHTML = originalContent;
          button.disabled = false;
        }, 2000);
        
        // Update cart count if function exists
        if (window.updateCartCount) {
          window.updateCartCount();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        button.innerHTML = originalContent;
        button.disabled = false;
        alert('Error adding item to cart');
      });
    });
  });
});

// Scroll effects initialization
function initializeScrollEffects() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { 
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  // Observe elements for scroll animations
  document.querySelectorAll('.fade-in-up, .trust-signal, .related-product-card, .feature-card').forEach(el => {
    el.classList.add('fade-in-up');
    observer.observe(el);
  });
}

// Initialize smooth scrolling for anchor links
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Product image lazy loading
function initializeLazyLoading() {
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          imageObserver.unobserve(img);
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
}

// Enhanced mobile menu handling
function initializeMobileOptimizations() {
  // Touch-friendly interactions for mobile
  if ('ontouchstart' in window) {
    document.body.classList.add('touch-device');
  }
  
  // Viewport height fix for mobile browsers
  function setVH() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  setVH();
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', setVH);
}

// Initialize all functionality when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initializeScrollEffects();
  initializeLazyLoading();
  initializeMobileOptimizations();
});

